import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IMessageGroupOutputModel, IMessageGroupMemberListModel, IMessageGroupModel, IMessageGroupMGInputModel, IMessageGroupMemberInputModel } from 'src/app/ViewModel/CommunicationModel';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { CommonService } from 'src/app/Service/Common.service';
import { groupBy } from 'lodash';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-distribution-list',
  templateUrl: './distribution-list.component.html',
  styleUrls: ['./distribution-list.component.css']
})
export class DistributionListComponent implements OnInit {
  @Input() addTabVal: number = 0;
  @Output() addTabValChange = new EventEmitter<number>();
  @Input() selectedGroupId!: number;
  @Input() receiverType: number = 1;
  @Input() selectedList: any[] = [];
  @Output() postGroup = new EventEmitter<any[]>();
  memberId: number = 0;
  groupList: IMessageGroupOutputModel[] = [];
  selectedGroupList: IMessageGroupOutputModel[] = [];
  public mGForm: FormGroup = new FormGroup({
    txtGroupName: new FormControl(),
  });
  public projectId!: number;
  cartSelectedList! : any[];
  cartSelectedListCopy!: any[];
  SearchLength: number = 0;
  cartList: IMessageGroupModel[] = [];
  cartCollection: any[] = [];
  cartSelectedCollection: any[] = [];
  cartTempCollection: any[] = [];
  selectedOptions = '';
  _leftTempCollection: any[] = [];
  _rightTempCollection: any[] = [];
  leftSearchValue = '';
  rightSearchValue = '';
  emittingList: any[] = [];
  _matGroupDefaultValues: any[] = [];
  dataSource: any[] = [];
  _selectArrowModel: selectArrowModel = new selectArrowModel();
  cartHelper: CartHelper = new CartHelper();
  public MGMembersList: IMessageGroupMemberInputModel[] = [];
  public editMGId: number = 0;
  public selectedMessageGroup: any;

  constructor(
    public communicationService: CommunicationService,
    public commonService: CommonService,
    public projectMemberLinkService: ProjectMemberLinkService,
    public notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
  }

  ngOnChanges() {
    this.memberId = this.commonService.getLoggedInUserId();
    if (this.addTabVal == 0) {
      this.cartSelectedCollection = [];
      this.cartCollection = [];
      this.getDistributionList();
    }
    else {
      this.cartSelectedCollection = [];
      this.cartCollection = [];
      this.getMemberList();
    }
  }

  async getMemberList() {
    let memberList = await this.projectMemberLinkService.getSelectedMemberList(this.commonService.getProjectId(), +this.selectedGroupId).toPromise();
    memberList.forEach((x: { memberId: any; memberName: any; }) => {
      let item: IMessageGroupModel = {
        value: x.memberId,
        text: x.memberName,
        selected: false,
        selectMode: '',
        memberList: null
      };
      this.cartCollection.push(item);
    });
    if (this.editMGId != 0) {
      let projectSelectedMembers = this.selectedMessageGroup.memberList;
      projectSelectedMembers.forEach((x: { value: any; text: any; }) => {
        let item: IMessageGroupModel = {
          value: x.value,
          text: x.text,
          selected: false,
          selectMode: '',
          memberList: null
        };
        this.cartSelectedCollection.push(item);
      });
      this.cartCollection = this.removeDuplicates(this.cartCollection, projectSelectedMembers, 'value');
    }

  }

  async getDistributionList() {
    this.groupList = await this.communicationService.GetMessageGroup({ MemberId: this.memberId , ProjectId :this.projectId}).toPromise();
    if (this.selectedList != undefined && this.selectedList.length > 0) {
      let alreadyselectedGroups = this.selectedList.filter(x => x.isGroup == true);
      alreadyselectedGroups.forEach(x => {
        let res:any = this.groupList.find(group => group['groupDescription'] == x.groupName);
        this.selectedGroupList.push(res);
      });
    }
    this.setCartValues();
    this.handleSelectArrows();
  }

  groupListBy(list: any[], keyGetter: { (group: any): any; (arg0: any): any; }) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  setCartValues() {
    this.cartCollection = [];
    this.cartSelectedCollection = [];
    const grouped = this.groupListBy(this.groupList, (group:any) => group.groupId);

    grouped.forEach((value: any[], key: number) => {
      let memberList: IMessageGroupModel[] = value.map(x => {
        return {
          value: x.memberId,
          text: x.memberName,
          selected: false,
          selectMode: '',
          memberList: null
        };
      });
      let item: IMessageGroupModel = {
        value: key.toString(),
        text: value[0].groupDescription,
        selected: false,
        selectMode: '',
        memberList: memberList
      };
      this.cartCollection.push(item);
    });
    this.dataSource = this.removeDuplicates(this.groupList, this.selectedGroupList, 'groupId');
    this.cartSelectedList = [];
    this.cartSelectedListCopy = [];
    this.selectedGroupList.forEach(eachgroup => {
      let cartValue= this.getAsCartSelectedValue(eachgroup['groupId'], eachgroup['groupDescription']);
      this.cartSelectedList.push(cartValue);
      this.cartSelectedListCopy.push(cartValue);
      this.cartCollection.find(x => x.value == eachgroup['groupId'].toString()).selected = true;
    });
    this.moveSelectedItems();
  }

  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }

  editMessageGroup(group: any) {
    this.editMGId = group.value;
    this.selectedMessageGroup = group;
    this.addTabVal = 1;
    this.mGForm.controls['txtGroupName'].setValue(group.text);
    this.cartSelectedCollection = [];
    this.cartCollection = [];
    this.getMemberList();
  }

  postMessageGroup() {
    this.postGroup.emit(this.cartSelectedCollection);
  }

  saveMessageGroup() {
    this.MGMembersList = [];
    if (this.cartSelectedCollection.length > 0) {
      this.cartSelectedCollection.forEach(member => {
        let memberId = +member.value;
        this.MGMembersList.push({
          MemberId: memberId,
          UserId: this.memberId,
          MessageGroupId: 0,
          GroupId: 1,
          ProjectId: this.commonService.getProjectId(),
          RoleId: 2,
          ReceiverType: 2,
          IsActive: true
        });
      });

      if (this.editMGId != 0) {
        this.selectedMessageGroup.memberList.forEach((member: { value: string | number; }) => {
          let memberId = +member.value;
          let alreadySelectedMember = this.cartSelectedCollection.findIndex(x => x.value == memberId);
          if (alreadySelectedMember == -1) {
            this.MGMembersList.push({
              MemberId: memberId,
              UserId: this.memberId,
              MessageGroupId: 0,
              GroupId: this.commonService.getLoggedInUserGroupId(),
              ProjectId: this.commonService.getProjectId(),
              RoleId: 2,
              ReceiverType: this.receiverType,
              IsActive: false
            });
          }
        });
      }

      let inputModel: IMessageGroupMGInputModel = {
        MemberId: this.memberId,
        OwnerId: this.memberId,
        GroupId: this.editMGId,
        ProjectId: this.commonService.getProjectId(),
        GroupDescription: this.getFormValue('txtGroupName', this.mGForm),
        IsActive: true,
        MessageGroupMembers: this.MGMembersList,
      };
      this.callService(inputModel);
    }
    else {
      this.notificationService.showToast("Minimum one member should be selected", "Warning");
    }
  }

  deleteMessageGroup(group: IMessageGroupModel) {
    let inputModel: IMessageGroupMGInputModel = {
      MemberId: this.memberId,
      OwnerId: this.memberId,
      GroupId: +group.value,
      ProjectId: 0,
      GroupDescription: group.text,
      IsActive: false,
      MessageGroupMembers: []
    };
    this.callService(inputModel);
  }

  callService(inputModel: IMessageGroupMGInputModel) {
    this.communicationService.InsertUpdateMessageGroup(inputModel).subscribe((res: StandardOutputModel) => {
      if (res.successCode == 200 || res.successCode == 205) {
        this.notificationService.showToast(res.successMessage, "Success");
        this.editMGId = 0;
        this.selectedMessageGroup = null;
        this.mGForm.reset();
        this.addTabVal = 0;
        this.addTabValChange.emit(this.addTabVal);
        this.getDistributionList();
      }
      else {
        this.notificationService.showToast(res.successMessage, "Error");
      }
    });
  }

  filterExistingRecords() {
    if (this._leftTempCollection && this._leftTempCollection.length === 0) {
      this._leftTempCollection = this.cartCollection;
    }
    this.cartCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim());
  }

  searchLeftCart() {
    if (this.SearchLength.toString().trim() === '0') {
      if (this._leftTempCollection && this._leftTempCollection.length === 0) {
        this._leftTempCollection = this.cartCollection;
      }
      this.cartCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim());
    } else {
      if (this.leftSearchValue.length >= this.SearchLength) {
        {
          this.setCartValues();
        }
        this.cartCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim());
      }
    }
  }

  searchRightCart() {
    if (this._rightTempCollection && this._rightTempCollection.length === 0) {
      this._rightTempCollection = this.cartSelectedCollection;
    }
    this.cartSelectedCollection = this.cartHelper.getFilteredCartItems(this._rightTempCollection, this.rightSearchValue.trim());
  }

  getAsCartSelectedValue(value: string | number, text: string) {
    value = value.toString().trim();
    text = text.trim();
    let output = {
      value,
      text: value + ' - ' + text
    };
    return output;
  }

  removeDuplicates(dataSource: any[], selectedArray: any[], key: string) {
    let filteredArray: any[] = [],
      grpdSelecetedArray = groupBy(selectedArray, key);

    dataSource.forEach((eachData: any) => {
      if (!(grpdSelecetedArray[eachData[key]] && grpdSelecetedArray[eachData[key]].length)) {
        filteredArray.push(eachData);
      }
    });
    return filteredArray;
  }

  moveSelectedItems() {
    let _tmpSelectedCollection: IMessageGroupModel[] = [];
    if (this._leftTempCollection.length === 0) {
      this._leftTempCollection = this.cartCollection;
    }

    this.cartCollection.forEach(element => {
      if (element.selected) {
        element.selected = false;
        element.selectMode = '';
        _tmpSelectedCollection.push(element);
      }
    });

    this.cartMoveSelectedItems(_tmpSelectedCollection);
    this.cartTempCollection = [];
    this.leftSearchValue = '';
  }

  cartMoveSelectedItems(_tmpSelectedCollection: any[]) {
    let _isRecordAvailable = false;
    let _selIndex = -1;
    let _leftTempIndex = -1;
    let selectedValueCount = 0;

    selectedValueCount = _tmpSelectedCollection.length;

    if (_tmpSelectedCollection.length > 0) {// if (this.cartCollection.length > 0) {
      _tmpSelectedCollection.forEach(element => {
        element.selected = false;
        _isRecordAvailable =
          this.cartHelper.isRecordAvailable(element['value'], this._rightTempCollection);

        // If record not available to right cart then push to it.
        if (!_isRecordAvailable) {
          this._rightTempCollection.push(element);
        }

        _selIndex = this.cartHelper.getMatchingIndex(this.cartCollection, element['value']);
        _leftTempIndex = this.cartHelper.getMatchingIndex(this._leftTempCollection, element['value']);

        if (_selIndex > -1 && _leftTempIndex > -1) {
          if (this.leftSearchValue.trim() === '') {
            this._leftTempCollection.splice(_leftTempIndex, 1);
          } else if (this.leftSearchValue.trim() !== '') {
            this.cartCollection.splice(_selIndex, 1);
            this._leftTempCollection.splice(_leftTempIndex, 1);
          }
        }
      });
      this.cartSelectedCollection = this._rightTempCollection.slice(0, 100);
      this.cartCollection = this._leftTempCollection.slice(0, 100);
      this.handleSelectArrows();
    }
  }

  moveAllItems() {
    let _isRecordAvailable = false;
    let _searchedCollection: IMessageGroupModel[] = [];
    if (this.cartCollection && this.cartCollection.length > 0) {
      // If right hand cart is empty
      if (this.cartSelectedCollection.length === 0) {
        if (this.leftSearchValue.trim() !== '') {
          this._rightTempCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue, 0, 100, 'all');
        } else {
          this._rightTempCollection = this._leftTempCollection;
        }
      } else if (this.cartSelectedCollection.length > 0) {
        if (this.leftSearchValue.trim() === '') {
          this._leftTempCollection.forEach(element => {
            element.selected = false;
            _isRecordAvailable = this.cartHelper.isRecordAvailable(element['value'], this._rightTempCollection);
            if (!_isRecordAvailable) {
              this._rightTempCollection.push(element);
            }
          });
        } else {
          _searchedCollection = this.cartHelper.getFilteredCartItems(this._leftTempCollection, this.leftSearchValue.trim(), 0, 100, 'all');
          _searchedCollection.forEach(element => {
            element.selected = false;
            this._rightTempCollection.push(element);
          });
        }
      }

      if (this.leftSearchValue.trim() !== '') {
        this._leftTempCollection = this.cartHelper.removeSelectedItems(this._leftTempCollection, this._rightTempCollection);
        this.cartCollection = this._leftTempCollection.slice(0, 100);
      } else {
        this.cartCollection = [];
        this._leftTempCollection = [];
      }
      this.leftSearchValue = '';
      this.cartSelectedCollection = this._rightTempCollection; // .slice(0, 100);
      this.handleSelectArrows();
    }
  }


  removeSelectedItems() {

    let _selIndex = -1;
    let _rightTempIndex = -1;
    let _isRecordAvailable = false;

    let selectedCount = 0;
    // If leftTemp Colln is empty then set the value = cart collection
    if (this._rightTempCollection.length === 0) {
      this._rightTempCollection = this.cartSelectedCollection;
    }


    if (this.cartSelectedCollection.length > 0) {
      this.cartSelectedCollection.forEach(element => {

        if (element) {
          // Moving only the selected items
          if (element.selected === true) {
            selectedCount++;

            _isRecordAvailable = this.cartHelper.isRecordAvailable(element['value'], this.cartCollection);
            element.selected = false;
            element.selectMode = '';

            // If record is not available then move to left side cart
            if (!_isRecordAvailable) {
              this._leftTempCollection.push(element);
            }
            _selIndex = this.cartHelper.getMatchingIndex(this.cartSelectedCollection, element['value']);
            _rightTempIndex = this.cartHelper.getMatchingIndex(this._rightTempCollection, element['value']);

            if (_selIndex > -1 && _rightTempIndex > -1) {
              this._rightTempCollection.splice(_rightTempIndex, 1);
            }
          }
        }
      });
      this.cartTempCollection = [];
      this.cartCollection = this._leftTempCollection.slice(0, 100);
      this.cartSelectedCollection = this._rightTempCollection.slice(0, 100);
      this.rightSearchValue = '';
      this.handleSelectArrows();
    }
  }


  removeAllItems() {
    let _isRecordAvailable = false;
    let _tmpCollection: any[] = [];

    let selectedCount = 0;
    selectedCount = this._rightTempCollection.length;

    if (this.cartSelectedCollection && this.cartSelectedCollection.length > 0) {

      // If right hand cart is empty
      if (this.cartCollection.length === 0) {
        if (this.rightSearchValue.trim() !== '') {
          this.cartCollection = this.cartHelper.getFilteredCartItems(this._rightTempCollection, this.rightSearchValue, 0, 100);
          this._leftTempCollection = this.cartHelper.getFilteredCartItems(this._rightTempCollection, this.rightSearchValue, 0, 100, 'all');

        } else {
          this.cartCollection = this._rightTempCollection.slice(0, 100);
          this._leftTempCollection = this._rightTempCollection;
        }
      } else if (this.cartCollection.length > 0) {
        if (this.rightSearchValue.trim() === '') {
          _tmpCollection = this._rightTempCollection;
        } else {
          _tmpCollection = this.cartHelper.getFilteredCartItems(this._rightTempCollection, this.rightSearchValue, 0, 100, 'all');
        }

        _tmpCollection.forEach(element => {
          element.selected = false;
          _isRecordAvailable = this.cartHelper.isRecordAvailable(element['value'], this._leftTempCollection);
          if (!_isRecordAvailable) {
            this._leftTempCollection.push(element);
          }
        });

        this.cartCollection = this._leftTempCollection.slice(0, 100);
      }

      if (this.rightSearchValue.trim() !== '') {

        this._rightTempCollection = this.cartHelper.removeSelectedItems(this._rightTempCollection, this._leftTempCollection);
        this.cartSelectedCollection = this._rightTempCollection.slice(0, 100);
      } else {
        this.cartSelectedCollection = [];
        this._rightTempCollection = [];
      }
      this.rightSearchValue = '';
      this.handleSelectArrows();
    }
  }

  handleSelectArrows(_location?: string) {

    if (_location) {
      if (_location === 'left') {
        if (this.cartTempCollection.length > 0) {

          this._selectArrowModel.isLeftAllDisabled = true;
          this._selectArrowModel.isLeftDisabled = false;
        } else {
          this._selectArrowModel.isLeftAllDisabled = false;
          this._selectArrowModel.isLeftDisabled = true;
        }
      } else if (_location === 'right') {

        if (this.cartTempCollection.length > 0) {
          this._selectArrowModel.isRightAllDisabled = true;
          this._selectArrowModel.isRightDisabled = false;
        } else {
          this._selectArrowModel.isRightAllDisabled = false;
          this._selectArrowModel.isRightDisabled = true;
        }
      }
    } else {

      if (this.cartCollection.length > 0) {
        this._selectArrowModel.isLeftAllDisabled = false;
        this._selectArrowModel.isLeftDisabled = true;
      } else {
        this._selectArrowModel.isLeftAllDisabled = true;
        this._selectArrowModel.isLeftDisabled = true;
      }

      if (this.cartSelectedCollection.length > 0) {
        this._selectArrowModel.isRightAllDisabled = false;
        this._selectArrowModel.isRightDisabled = true;
      } else {
        this._selectArrowModel.isRightAllDisabled = true;
        this._selectArrowModel.isRightDisabled = true;
      }
    }
  }

  getCartItems(selectedItem: any, _location: string, _value?: string, _action?: string) {
    if (!selectedItem.option || selectedItem.option === '') {
      if (selectedItem.dataItem.memberList == null) {
        return;
      }
    }
    let _selectedItem: any = {};
    let _selectedCartItemText = '';
    let _collection: any[] = [];
    let _selectedValue = '';
    let _index = -1;
    let _isKeyEvent = false;
    let _selectedText = '';
    let _selectedCartItem: any[] = [];

    if (_action !== 'keyEvent') {
      if (!_value || _value === '') {
        if (!selectedItem.option || selectedItem.option === '') {
          _selectedValue = selectedItem.dataItem.value;
        }
        else {
          _selectedValue = selectedItem.option._value;
        }
      } else if (_value) {
        _selectedValue = _value;
      }

      if (_location === 'left') {
        _selectedCartItem = this.cartHelper.getFilteredCartItems(this.cartCollection, _selectedValue);
      } else if (_location === 'right') {
        _selectedCartItem = this.cartHelper.getFilteredCartItems(this.cartSelectedCollection, _selectedValue);
      }

    }
    // else if (_action === 'keyEvent') {
    //   _value = selectedItem.target.id;
    //   this.handleShiftSelection(_value, selectedItem);
    //   _isKeyEvent = true;
    // }

    if (!_isKeyEvent) {
      if (_location === 'left') {
        _collection = this.cartCollection;
        this._selectArrowModel.isLeftDisabled = false;
      } else if (_location === 'right') {
        _collection = this.cartSelectedCollection;
        this._selectArrowModel.isRightDisabled = false;
      }

      let _isSelected: boolean;
      if (!selectedItem.option || selectedItem.option === '') {
        _isSelected = true;
      }
      else {
        _isSelected = selectedItem.option._selected;
      }

      if (_isSelected) {
        _selectedItem = _selectedCartItem[0];
        this.cartTempCollection.push(_selectedItem);
      } else if (!_isSelected) {
        _selectedCartItemText = this.cartHelper.getSelectedCartText(_selectedValue, _collection);
        if (this.cartTempCollection.length > 0) {
          _index = this.cartTempCollection.findIndex(element => {
          
              return element &&((element['value'] === _selectedValue) && (element['text'] === _selectedCartItemText));
           
          });

          if (_index > -1) {
            this.cartTempCollection.splice(_index, 1);
          }
        }
      }

      if (_location === 'left') {
        if (this.cartSelectedCollection && this.cartSelectedCollection.length > 0) {
          for (let i = 0; i < this.cartSelectedCollection.length; i++) {
            this.cartSelectedCollection[i].selected = false;
          }

          this._selectArrowModel.isLeftDisabled = false;
          this._selectArrowModel.isRightDisabled = true;

        }
        _index = this.cartHelper.getCartIndex(_selectedValue, this.cartCollection);

        // Move to right on dbl click
        if (_action === 'dblclick') {
          this.cartCollection.filter(element => {
            element.selected = false;
          });
          this.cartCollection[_index].selected = true;
        } else {
          this.cartCollection[_index].selected = !this.cartCollection[_index].selected;
        }
      } else if (_location === 'right') {
        if (this.cartCollection && this.cartCollection.length > 0) {
          for (let i = 0; i < this.cartCollection.length; i++) {
            this.cartCollection[i].selected = false;
          }
          this._selectArrowModel.isLeftDisabled = true;
          this._selectArrowModel.isRightDisabled = false;
        }
        _index = this.cartHelper.getCartIndex(_selectedValue, this.cartSelectedCollection);

        // Move to left on dbl click

        if (_action === 'dblclick') {
          this.cartSelectedCollection.filter(element => {
            element.selected = false;
          });
          this.cartSelectedCollection[_index].selected = true;
        } else {
          this.cartSelectedCollection[_index].selected = !this.cartSelectedCollection[_index].selected;
        }
      }
    }
    this.handleSelectArrows(_location);
  }

}

export class selectArrowModel {
  isLeftDisabled: boolean = true
  isLeftAllDisabled: boolean = true
  isRightDisabled: boolean = true
  isRightAllDisabled: boolean = true
}

export class CartHelper {
  getCartIndex(_value: string, _collection: any[]): number {
    let _index = -1;
    if (_collection.length > 0) {
      _index = _collection.findIndex(element => {
        return (element['value'] === _value);
      });
    }
    return _index;
  }

  getFilteredCartItems(_collection: any[], _searchValue: string, minLimit?: number, maxLimit?: number, _condition?: string): any[] {
    let _outCollection: any[] = [];
    if (!minLimit) {
      minLimit = 0;
    }
    if (!maxLimit) {
      maxLimit = 100;
    }

    if (!_condition) {
      _outCollection =
        _collection.filter(option =>
          option.text.toLowerCase().includes(_searchValue.toString().toLowerCase().trim()))
          .slice(minLimit, maxLimit);
    } else if (_condition === 'all') {
      _outCollection =
        _collection.filter(option =>
          option.text.toLowerCase().includes(_searchValue.toString().toLowerCase().trim()));
    }
    return _outCollection;
  }

  getMatchingIndex(_collection: any[], _value: string): number {
    let _index = -1;

    _index = _collection.findIndex(cartElement => {
      return cartElement['value'] === _value;
    });

    return _index;

  }

  isRecordAvailable(_value: string, _collection: any[]): boolean {
    let _isRecordAvailable = false;
    let _index = -1;
    if (_collection.length > 0) {
      _index = this.getMatchingIndex(_collection, _value);
      if (_index > -1) {
        _isRecordAvailable = true;
      }
    }

    return _isRecordAvailable;
  }

  getSelectedCartText(_value: string, _originalCollection: any[]): string {
    let _selectedCartItemText = '';
    let _index = -1;
    if (_originalCollection && _originalCollection.length > 0) {
      _index = _originalCollection.findIndex(element => {
        return (element['value'] === _value);
      });
      if (_index > -1) {
        _selectedCartItemText = _originalCollection[_index]['text'];
      }
    }


    return _selectedCartItemText;
  }

  removeSelectedItems(_collection: any[], _removingList: any[]): any[] {
    let index = -1;

    _removingList.filter(element => {
      index = -1;
      index = this.getMatchingIndex(_collection, element['value']);
      if (index > -1) {
        _collection.splice(index, 1);
      }
    });
    return _collection;
  }
}
